import React from 'react';

const socialLinks = [
  {
    name: 'LinkedIn',
    href: '#',
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" className="w-5 h-5">
        <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" fill="#111"/>
      </svg>
    ),
  },
  {
    name: 'X',
    href: '#',
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true" className="w-5 h-5">
        <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" fill="#111"/>
      </svg>
    ),
  },
  {
    name: 'Instagram',
    href: '#',
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" className="w-5 h-5">
        <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" fill="#111"/>
      </svg>
    ),
  },
];

const offices = [
  {
    country: 'United States',
    flag: '🇺🇸',
    name: 'Anantla Inc.',
    address: [
      '2261 Market Street',
      'STE 86286, San Francisco,',
      'CA 94114, United States',
    ],
  },
  {
    country: 'Australia',
    flag: '🇦🇺',
    name: 'Anantla Australia',
    address: [
      'Altona Meadows VIC 3028',
      'Melbourne, Australia'
    ],
  },
  {
    country: 'Indonesia',
    flag: '🇮🇩',
    name: 'Anantla Indonesia',
    address: [
      '18 Parc Place SCBD Jl Jendral Sudirman',
      'Senayan, Kebayoran Baru',
      'Kota Adm. Jakarta Selatan DKI Jakarta',
    ],
  },
  {
    country: 'Singapore',
    flag: '🇸🇬',
    name: 'Anantla Singapore',
    address: [
      '6 Raffles Blvd, #03-308 Marina Square,',
      'Singapore 039594',
    ],
  },
];

const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-white pt-10 pb-6">
      {/* Top horizontal line */}
      <div className="border-t border-white/10 mb-8" />

      {/* Centered copyright and disclaimer */}
      <div className="text-center mb-2">
        <div className="text-gray-200 text-base font-medium">© 2025 Anantla Inc. All rights reserved.</div>
        <div className="text-gray-400 font-semibold text-xs tracking-wide mt-1 mb-6 uppercase">
          WE DO NOT PROCESS TRANSACTIONS OR MANAGE CLIENT FUNDS AS PART OF OUR SERVICES.
        </div>
      </div>

      {/* 3-column layout */}
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-y-12 gap-x-16 my-10">
        {/* Left: Connect With Us */}
        <div>
          <div className="font-bold text-lg mb-4">Connect With Us</div>
          <div className="flex gap-4 mb-6">
            {socialLinks.map(link => (
              <a key={link.name} href={link.href} aria-label={link.name} className="bg-white rounded-full w-9 h-9 flex items-center justify-center hover:opacity-80 transition-opacity">
                {link.icon}
              </a>
            ))}
          </div>
          <img
            src="https://payxb.co/payment-1.svg"
            alt="Trusted Payment Badges"
            className="h-8 md:h-9 w-auto mt-2"
            loading="lazy"
            draggable="false"
            style={{ filter: 'brightness(0.85)' }}
          />
        </div>
        {/* Center & Right: Our Offices (2-column grid) */}
        <div className="md:col-span-2">
          <div className="font-bold text-lg mb-6">Our Offices</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
            {/* Row 1: US & Indonesia */}
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 flex items-start pt-1">
                <span className="text-2xl">{offices[0].flag}</span>
              </div>
              <div>
                <div className="font-semibold flex items-center">{offices[0].name}</div>
                <div className="text-gray-300 text-sm leading-tight">
                  {offices[0].address.map((line, i) => <div key={i}>{line}</div>)}
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 flex items-start pt-1">
                <span className="text-2xl">{offices[2].flag}</span>
              </div>
              <div>
                <div className="font-semibold flex items-center">{offices[2].name}</div>
                <div className="text-gray-300 text-sm leading-tight">
                  {offices[2].address.map((line, i) => <div key={i}>{line}</div>)}
                </div>
              </div>
            </div>
            {/* Row 2: Australia & Singapore */}
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 flex items-start pt-1">
                <span className="text-2xl">{offices[1].flag}</span>
              </div>
              <div>
                <div className="font-semibold flex items-center">{offices[1].name}</div>
                <div className="text-gray-300 text-sm leading-tight">
                  {offices[1].address.map((line, i) => <div key={i}>{line}</div>)}
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 flex items-start pt-1">
                <span className="text-2xl">{offices[3].flag}</span>
              </div>
              <div>
                <div className="font-semibold flex items-center">{offices[3].name}</div>
                <div className="text-gray-300 text-sm leading-tight">
                  {offices[3].address.map((line, i) => <div key={i}>{line}</div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
